import React from 'react';
import { Home, Radio, Users, User, PlusCircle, Shield, Settings, BarChart } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';
import { cn } from '../utils';
import { useAuth } from '../context/AuthContext';
import { canManagePlatform } from '../utils/permissions';

const NavItem = ({ icon: Icon, label, to }) => {
  const location = useLocation();
  const active = to === '/' 
    ? location.pathname === '/' 
    : location.pathname.startsWith(to);

  return (
    <Link to={to} className={cn(
      "flex flex-col items-center justify-center flex-1 py-2 cursor-pointer transition-all duration-200 active:scale-90",
      active ? "text-brand-indigo" : "text-gray-400"
    )}>
      <Icon size={24} className={cn("transition-all duration-300", active ? "fill-brand-indigo/10 scale-110" : "hover:scale-110")} />
      <span className={cn(
        "text-[10px] font-bold mt-1 uppercase tracking-[0.15em] transition-all duration-300",
        active ? "opacity-100" : "opacity-40"
      )}>
        {label}
      </span>
    </Link>
  );
};

const BottomNav = ({ onCreateClick }) => {
  const { user } = useAuth();
  const isPlatformAdmin = canManagePlatform(user);

  return (
    <div className="md:hidden fixed bottom-0 left-0 right-0 bg-white/95 backdrop-blur-md border-t border-gray-100 z-[70] shadow-[0_-4px_20px_rgba(0,0,0,0.03)] pb-safe">
      <div className="max-w-7xl mx-auto flex items-center justify-between px-4 pt-1">
        {isPlatformAdmin ? (
          <>
            <NavItem icon={Shield} label="Admin" to="/admin" />
            <NavItem icon={Users} label="Users" to="/admin/users" />
            <NavItem icon={BarChart} label="Stats" to="/admin/analytics" />
            <NavItem icon={Settings} label="Settings" to="/admin/settings" />
          </>
        ) : (
          <>
            <NavItem icon={Home} label="Home" to="/" />
            <NavItem icon={Radio} label="Live" to="/live" />
            <div className="flex-1 flex justify-center -mt-12 relative">
              <button 
                onClick={onCreateClick}
                className="bg-brand-indigo text-white p-4 rounded-2xl shadow-[0_8px_25px_rgba(99,102,241,0.4)] active:scale-90 transition-all duration-500 border-4 border-white hover:rotate-12 relative z-10 group"
                aria-label="Quick Create"
              >
                <PlusCircle size={32} className="group-hover:scale-110 transition-transform duration-500" />
              </button>
              <div className="absolute top-4 w-12 h-12 bg-brand-indigo/20 rounded-2xl blur-xl animate-pulse"></div>
            </div>
            <NavItem icon={Users} label="Communities" to="/communities" />
            <NavItem icon={User} label="Profile" to="/profile" />
          </>
        )}
      </div>
    </div>
  );
};

export default BottomNav;
